export const ar = {
  badge: "مجدي حجازي للمنسوجات",
  heroTitle: "طباعة أقمشة عالية الجودة بخدمة مصنع موثوقة.",
  heroText:
    "نساعد العلامات التجارية وتجار الجملة والمصنعين على تحويل التصاميم إلى أقمشة مطبوعة بجودة ثابتة ونتائج نظيفة ودعم سريع.",
  callUs: "اتصل بنا",
  emailUs: "راسلنا",
  countries: "الدول التي نخدمها",
  countriesValue: "3",
  clients: "العملاء الذين خدمناهم",
  clientsValue: "40+",
  offerLabel: "ما الذي نقدمه",
  offerTitle: "معلومات واضحة وعرض احترافي مميز.",
  h1Title: "طباعة منسوجات دقيقة",
  h1Desc:
    "طباعة أقمشة عالية الجودة للملابس والزي الموحد والمواد الدعائية وطلبات الإنتاج الخاصة.",
  h2Title: "التزام في المواعيد",
  h2Desc:
    "من تطوير العينات إلى الإنتاج بكميات كبيرة، نركز على الالتزام بالجداول الزمنية والتواصل الواضح.",
  h3Title: "طلبات مخصصة مرحب بها",
  h3Desc:
    "ندعم مجموعة متنوعة من النقشات والألوان والتشطيبات ومتطلبات الأقمشة بما يناسب مشروعك.",
  aboutLabel: "عن المصنع",
  aboutTitle: "نقدّم دعماً حقيقياً لإنتاج المنسوجات بعناية وثبات.",
  aboutText1:
    "يخدم مصنعنا العملاء الباحثين عن طباعة منسوجات احترافية مدعومة بخبرة عملية في التصنيع. سواء كنت تحتاج إلى نقوش متكررة أو ألوان خاصة بعلامتك التجارية أو دعماً إنتاجياً لأقمشة مخصصة، فإننا نهدف إلى تقديم نتائج نظيفة وآلية عمل واضحة.",
  aboutText2: "",
  contactLabel: "معلومات التواصل",
  phone: "الهاتف",
  email: "البريد الإلكتروني",
  address: "العنوان",
  hours: "ساعات العمل",
  phoneValue: "+201118506001",
  emailValue: "sales@magdihegazy.com",
  addressValue: "بلوك 201، قطعة 800، مدينة بدر، مصر",
  hoursValue: "السبت – الخميس، 8:00 صباحاً – 6:00 مساءً",
  switchLanguage: "English",
};
